import type { IProjects } from '../../stores/projects';

type ProjectLoadState = Pick<IProjects, 'initialized'>;

/**
 * Should the app kick off a project load? Only while projects are still
 * uninitialized and no load is already in flight.
 *
 * Lives in this sibling util (not in `AppLoader.tsx`) so the component file
 * exports only components — a non-component export there breaks Fast Refresh.
 */
export function shouldLoadProjects(projects: ProjectLoadState, loading: boolean): boolean {
  return !projects.initialized && !loading;
}
